import React, { useState } from "react";
import styles from "./allIncome.module.css";
import { Home } from "react-feather";
import Helmet from "react-helmet";
import Footer from "../../../components/Footer";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "../../../components/Loader";
import { Typography } from "@mui/material";
import IncomeGrid from "./components/income-grid/IncomeGrid";
import IncomeList from "./components/income-list/IncomeList";

const AllIncome = () => {
  const [isGridView, setIsGridView] = useState(false);
  const [hasGridRendered, setHasGridRendered] = useState(false);

  const handleView = (view) => {
    if (view === "grid") {
      setIsGridView(true);
      setHasGridRendered(true);
    } else {
      setIsGridView(false);
    }
  }

  return (<React.Fragment>
    <Helmet title="Income" />

    <div className={`${styles.pageTitleWrap}`}>
      <Typography display="inline" className={`${styles.pageTitle}`}>Income</Typography>
      <nav aria-label="breadcrumb">
        <ol className={`${styles.breadcrumb}`}>
          <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Income</li>
          <li className={`${styles.breadcrumbItem} ${styles.active}`}>All Income</li>
        </ol>
      </nav>
    </div>

    {/* List View */}
    <div style={{ display: isGridView ? "none" : "block" }}>
      <IncomeList handleView={handleView} />
    </div>

    {/* Grid View */}
    {hasGridRendered && (
      <div style={{ display: isGridView ? "block" : "none" }}>
        <IncomeGrid handleView={handleView} />
      </div>
    )}
    <Footer />
  </React.Fragment>);
};

export default withAuthenticationRequired(AllIncome, {
  onRedirecting: () => <Loader />,
});